import { useTranslate } from '@tolgee/react';
import { useMemoizedFn } from 'ahooks';

export const useReturnTypeDisplay = () => {
  const { t } = useTranslate();

  return useMemoizedFn((returnType: Conversation.Trade.IReturnType) => {
    const returnTypeMap = {
      ONLY_REFUND: t('trade.仅退款'),
      RETURN_REFUND: t('trade.退货退款'),
      CHANGE: t('换货'),
    };
    return returnTypeMap[returnType] ?? t('trade.退货退款');
  });
};
